import { render, staticRenderFns } from "./rightOrder.vue?vue&type=template&id=4f9f7476&scoped=true&"
import script from "./rightOrder.vue?vue&type=script&lang=js&"
export * from "./rightOrder.vue?vue&type=script&lang=js&"
import style0 from "./rightOrder.vue?vue&type=style&index=0&id=4f9f7476&lang=scss&scoped=true&"
import style1 from "./rightOrder.vue?vue&type=style&index=1&id=4f9f7476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9f7476",
  null
  
)

export default component.exports